/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-caret-padding',
  templateUrl: './theme-option-tooltips-caret-padding.component.html',
  styleUrls: ['./theme-option-tooltips-caret-padding.component.css']
})
export class ThemeOptionTooltipsCaretPaddingComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_caretPadding';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_caretPadding', value);
  }

}
